import React, { Component, useEffect, useState } from 'react';
import ParticipatingSchemesView from './ParticipatingSchemesView';
import crmservices from '../../wsclient/crmservices';
import TermAndConditions from './TermAndConditions'
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';


function ParticipatingSchemes(props){

    const [showLoading, onShowLoading] = useState(false);
    const [reward_schemes, setRewardSchemes] = useState({});
    const [itemToBeJoin, setItemToBeJoin] = useState(null);
    const [showTermAndCondition, setShowTermAndCondition] = useState(false);
    const [message, setMessage] = useState(null);

    useEffect(()=>{
        getRewardSchemes();
    },[])

    const getRewardSchemes = async () =>{
        onShowLoading(true);
        try {
            let result = await crmservices.rewards.getRewardSchemes();
            if (result.code == 'OK') {
                setRewardSchemes(result.data);
            } else {
                console.log("ger rewards schemes error:", result);
            }
        } catch (error) {
            console.log("ger rewards schemes exception:", error);
        }
        onShowLoading(false);
    }
    
    const createListSchemes = () =>{
        let joined = [];
        let available = [];
        if(reward_schemes&&reward_schemes.content){
            reward_schemes.content.forEach(element => {
                if (!element.is_joined) {
                    available.push(element);
                } else {
                    joined.push(element);
                }
            });
        }

        return { joinedSchemes: joined, availableSchemes: available }
    }

    const onShowTermAndCondition = (item) =>{
        setItemToBeJoin(item);
        setShowTermAndCondition(!showTermAndCondition);
    }

    const onRegister = async(itemToBeJoin) =>{
        setShowTermAndCondition(false);
        onShowLoading(true);
        try {
            let result = await crmservices.rewards.signUpRewardScheme({ ...itemToBeJoin, reward_scheme_id: itemToBeJoin.id })
            if (result.code === 'OK') {
                await getRewardSchemes();
                showMessage(true, t('REWARDS_SCHEME_SIGN_UP_SUCCESS') + itemToBeJoin.name);
            } else {
                showMessage(true, t('REWARDS_SCHEME_SIGN_UP_FAIL') + itemToBeJoin.name);
            }
        } catch (error) {
            console.log("on register new scheme exception:", error);
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onSignOutScheme = async(item) =>{
        onShowLoading(true);
        try{
            let result = await crmservices.rewards.signOutRewardScheme({reward_scheme_id: item.id});
            if (result.code === 'OK') {
                await getRewardSchemes();
                showMessage(true, t('REWARDS_SCHEME_SIGN_OUT_SUCCESS'));
            } else {
                showMessage(true, t('REWARDS_SCHEME_SIGN_OUT_FAIL'));
            }
        }catch(error){
            console.log("on sign out scheme error:",error);
            showMessage(true, t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const showMessage = (status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        })
    }

    return (
        <div>
            <ParticipatingSchemesView
                showLoading = {showLoading}
                open = {props.open}
                onClose = {props.onCloseItem}
                joinedSchemes={createListSchemes().joinedSchemes}
                availableSchemes={createListSchemes().availableSchemes}
                showTermAndCondition={showTermAndCondition}
                onShowTermAndCondition={onShowTermAndCondition}
                itemToBeJoin={itemToBeJoin}
                onRegister={onRegister}
                onSignOutScheme = {onSignOutScheme}/>

                <TermAndConditions 
                    onRegister={onRegister} 
                    itemToBeJoin={itemToBeJoin} 
                    open={showTermAndCondition} 
                    onClose={onShowTermAndCondition} />

                {message && <ModalAlert
                open={message.show}
                onClose={showMessage}
                message={message.content}
            />}
        </div>
    );
}

export default ParticipatingSchemes;